import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

@Component({
  selector: 'formly-array-type',
  template: `
    <div class="formly-array">
      <h2 *ngIf="to.label">{{ to.label }}</h2>
      <!-- <p *ngIf="to.description">{{ to.description }}</p> -->

      <div class="alert alert-danger" role="alert" *ngIf="showError && formControl.errors">
        <formly-validation-message [field]="field"></formly-validation-message>
      </div>

      <div class="formly-drag-drop" (cdkDropListDropped)="drop($event)" cdkDropList>
        <div cdkDrag class="formly-drag-drop__item" *ngFor="let field of field.fieldGroup; let i = index">
          <div cdkDragHandle>
            <span class="material-symbols-outlined notranslate">drag_indicator</span>
          </div>

          <formly-field [field]="field"></formly-field>

          <div *ngIf="field.templateOptions.removable !== false">
            <button mat-button color="warn">
              <span class="material-symbols-outlined notranslate" (click)="remove(i)">delete</span>
            </button>
          </div>
        </div>
      </div>

      <div class="formly-array__actions">
        <button class="btn btn-primary" type="button" (click)="add()">+</button>
      </div>
    </div>
  `
})
export class ArrayTypeComponent extends FieldArrayType {
  drop(event: CdkDragDrop<string[]>) {
    console.log(this.model, this.field);
    moveItemInArray(this.field.fieldGroup, event.previousIndex, event.currentIndex);
    moveItemInArray(this.model, event.previousIndex, event.currentIndex);
  }
}
